import { useState } from "react";
import { Linking, Platform, View } from "react-native";
import { Button } from "~/components/ui/Button";
import { CaptionText } from "~/components/ui/Text";
import { useAuth } from "~/hooks/useAuth";
import { usePurchases } from "~/hooks/usePurchases";
import { spacing, useTheme } from "~/styles/theme";

/**
 * Lets a subscribed user change or cancel their plan. Native uses RevenueCat's
 * Customer Center; web opens the Web Billing management page. An account with
 * access but no subscription of its own (comped access) has nothing to manage,
 * and says so rather than failing silently.
 */
export function ManageSubscription() {
  const { colors } = useTheme();
  const { user } = useAuth();
  const purchases = usePurchases(user?.id ?? null);
  const [message, setMessage] = useState("");

  const open = async () => {
    setMessage("");
    try {
      if (purchases.supportsCustomerCenter && Platform.OS !== "web") {
        await purchases.presentCustomerCenter();
        return;
      }
      const url = await purchases.getManagementUrl();
      if (!url) {
        setMessage(
          "There's no billing subscription on this account to manage.",
        );
        return;
      }
      await Linking.openURL(url);
    } catch (error) {
      setMessage(
        error instanceof Error && error.message
          ? error.message
          : "Couldn't open subscription management. Try again shortly.",
      );
    }
  };

  return (
    <View style={{ gap: spacing.xs }}>
      <Button
        label={purchases.managing ? "Opening…" : "Manage subscription"}
        variant="secondary"
        fullWidth
        disabled={!purchases.configured || purchases.managing}
        onPress={() => void open()}
      />
      {message ? (
        <CaptionText color={colors.muted}>{message}</CaptionText>
      ) : null}
    </View>
  );
}
